// Module
var code = "<div class=\"row loan-variation-details\"> <div class=\"title\"><strong>Variation Details</strong></div> <div class=\"summary-row\" ng-repeat=\"variationDetail in vm.loanVariationDetails.summaryList track by $index\"> <div class=\"details\" ng-bind-html=\"variationDetail\"></div> </div> </div> ";
// Exports
module.exports = code;